import React from "react";
import "../../styles/stemSubjects.css";
import { FaCalculator, FaAtom, FaMicroscope, FaGlobeAmericas, FaVideo, FaFilm, FaVial, FaQuestionCircle } from "react-icons/fa";

const stemData = {
  introduction: "The STEM Subjects program is designed to revolutionise high school education by integrating interactive and multimedia-based learning experiences. By combining expert-led videos, engaging animations, virtual labs, and interactive quizzes, we aim to create a dynamic and engaging way for students to learn Science, Technology, Engineering, and Mathematics.",
  subjects: [
    { name: "Mathematics", icon: <FaCalculator size={30} /> },
    { name: "Physical Sciences", icon: <FaAtom size={30} /> },
    { name: "Life Sciences", icon: <FaMicroscope size={30} /> },
    { name: "Geography", icon: <FaGlobeAmericas size={30} /> },
  ],
  components: [
    { title: "Human Videos", description: "Learn from experts explaining concepts and demonstrating experiments.", icon: <FaVideo size={30} /> },
    { title: "Animated Videos", description: "Engaging 2D and 3D animations to bring STEM topics to life.", icon: <FaFilm size={30} /> },
    { title: "Virtual Labs", description: "Simulated experiments for safe, hands-on exploration.", icon: <FaVial size={30} /> },
    { title: "Quizzes", description: "Interactive assessments to reinforce learning.", icon: <FaQuestionCircle size={30} /> }
  ]
};

const STEMSubjects = () => {
  return (
    <div className="stem-subjects">
      <h1>STEM Subjects</h1>

      {/* Introduction Section */}
      <section className="intro">
        <p>{stemData.introduction}</p>
      </section>

      {/* Subjects Section */}
      <section className="subjects">
        <h2>Subjects Covered</h2>
        <ul className="subjects-list">
          {stemData.subjects.map((subject, index) => (
            <li key={index} className="subject-item"> {/* Added className */}
            <span className="subject-icon">{subject.icon}</span> {/* Added span */}
            <span className="subject-name">{subject.name}</span> {/* Added span */}
        </li>
        ))}
        </ul>
      </section>

      {/* Learning Components Section */}
      <section className="learning-components">
        <h2>Learning Components</h2>
        <div className="components-grid">
          {stemData.components.map((comp, index) => (
            <div key={index} className="component-card">
              {comp.icon}
              <h3>{comp.title}</h3>
              <p>{comp.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default STEMSubjects;
